module.exports = {
	colors: {
		main: '#FF9A4A',
		sec: '#485041',
		alt: '#FFFFFF',
	},

	showFunds: true,
	showBuses: true,
	useBusAssistantGPS: true,
	showHomeworks: true,
	showSchoolDay: false,
	showLanguages: false,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['0934131159', '0994487458', '0941995956', '0997481945'],
		phones: ['31613966251+'],
		address: 'عفرين _طريق معراتة _جانب مطعم غراند عفرين',
		data: [36.616838, 36.936511],
		email: null,
		facebook: null,
		privacy: 'https://qimmah.edunixsystem.com/al-qimmah-school-privacy.html',
		details: [
			{
				title: 'مدرسة القمة الدولية للتعليم والتدريب',
				content: [],
			},
		],
	},

	pwa: {
		name: 'مدرسة القمة الدولية للتعليم والتدريب',
		shortName: 'مدرسة القمة الدولية للتعليم والتدريب',
		description: 'مدرسة القمة الدولية للتعليم والتدريب',
	},
};
